module.exports = __webpack_public_path__ + "static/img/product06-3.8d05d693.png";